import { useFormik } from 'formik';
import { useCookie } from 'react-use';
import map from 'lodash/map';
import { getUtmFromSession } from 'helpers/utm-utils';
import { ReportFormValues } from 'templates/report';
import { NewsletterValues } from 'hooks/use-newsletter';
import { SignUpFormModel } from 'pages/sign-up';
import { DownloadModalValues } from 'components/organisms/DownloadModal';
import { ReferralsFormModel } from 'pages/referrals';
import { InfoFormSection } from 'components/organisms/InfoFormSection';

interface UtmFields {
  utm_name?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

type HubspotInitialValues = SignUpFormModel | ReportFormValues | DownloadModalValues | NewsletterValues | ReferralsFormModel | InfoFormSection;

interface UseHubspotProps {
  initialValues: HubspotInitialValues;
  schema: Object;
  post: Function;
  file?: string;
  referrals?: boolean;
  gtmVariables: { [key: string ]: string;}
}

const useHubspot = ({ initialValues, schema, post, file = '', referrals = false, gtmVariables }: UseHubspotProps) => {
  const isBrowser = typeof window !== 'undefined';
  const hutk = isBrowser ? useCookie('hubspotutk') : '';
  const pageUri = isBrowser ? window.location.href : null;
  const pageName = isBrowser ? document.title : null;

  function utm2fields(utm: UtmFields) {
    return map(utm, (value, name) => ({ name, value }));
  }

  return useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit:  async (values: any) => {

        const hsfields = referrals && {
          distributor_rep__c: `${values.firstname} ${values.lastname}`,
          distributor_email__c: values.email,
          referrer_company:
            values.company === 'Other' ? values.companyOther : values.company,
          core_mark_division__c: values.coreMarkDivision,
          firstname: values.referfirstname,
          lastname: values.referlastname,
          email: values.referemail,
          company: values.refercompany,
          phone: values.referphone,
        };

        if(values.terms) delete values.terms;

      const fields = Object.entries(referrals ? hsfields : values).map(([key, value]) => ({
        name: key,
        value
      }));

      const data = {
        submittedAt: Date.now(),
        fields: [
          ...fields, ...utm2fields(getUtmFromSession()),
          {
            name: 'most_recent_source_drill_down_2',
            value: window.location.href,
          },
        ],
        context: { hutk: hutk[0], pageUri, pageName },
      };

      await post(data).then ((res) => {
        if (res?.status !== 'error' && window.dataLayer) {
          window.dataLayer.push({...gtmVariables, leadFormData: values });
        }
      });

      if (file) window.location.assign(file);
    }
  })
};

export default useHubspot;
